import { type FC, useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { nanoid } from 'nanoid'
import { IconButton, type ITooltipProps } from 'shared/ui'
import { TriggerTooltip } from 'shared/ui/TriggerTooltip/TriggerTooltip'
import { dropDownStore } from 'shared/ui/Dropdown/store'
import { type AiAssistantStore } from 'widgets/AIAssistant'
import { AIAssistantContent } from 'widgets/AIAssistant/ui/AIAssistantContent/AIAssistantContent'

type IAIAssistantActionProps = {
  aiAssistantStore: AiAssistantStore
  placementMainContent?: ITooltipProps['placement']
  isVariantContained?: { value: boolean }
  isDisabledObj?: { value: boolean }
}

export const AIAssistantAction: FC<IAIAssistantActionProps> = observer((props) => {
  const { aiAssistantStore, placementMainContent = 'top-start', isDisabledObj } = props
  const { open, setOpen, triggerElement, handleTooltipOpen, isVariantContained } = aiAssistantStore
  const [dropdownId] = useState(() => nanoid())

  const onClickAway = () => {
    setOpen(false)
  }

  const handleOpen = () => {
    dropDownStore.allHide(dropdownId)
    handleTooltipOpen()
  }

  useEffect(() => {
    dropDownStore.setItem(dropdownId, { setOpen, open })

    return () => {
      dropDownStore.deleteItem(dropdownId)
    }
  }, [dropdownId])

  useEffect(() => {
    return () => {
      setOpen(false)
    }
  }, [])

  const getTooltipLabel = () => {
    if (open) {
      return ''
    }
    if (isDisabledObj?.value) {
      return 'Please enter text to enable AI'
    }
    return 'AI assistant'
  }
  return (
    <>
      <IconButton
        icon={'stars'}
        onClick={handleOpen}
        active={open}
        ariaLabel={'AIAssistant_stars'}
        variant={isVariantContained?.value ? 'contained' : 'icon'}
        color={isVariantContained?.value ? 'passiveSecondary' : 'secondary'}
        tooltipProps={{ label: getTooltipLabel(), placement: 'top' }}
        disabled={isDisabledObj?.value}
      />

      {triggerElement && (
        <TriggerTooltip
          placement={placementMainContent}
          trigger={triggerElement}
          open={open}
          component={<AIAssistantContent aiAssistantStore={aiAssistantStore} />}
          color={'white'}
          onClickAway={onClickAway}
          marginBottom={13}
        />
      )}
    </>
  )
})
